import { v4 as uuidv4 } from 'uuid';
import { useDispatch } from 'react-redux';
import { unzip } from 'unzipit';
import { setFile } from '../../../../redux/slicers/admin/curatorProjectArchiveSlicer';
import { useNavigate } from 'react-router-dom';
import { getCuratorPath, openCuratorRoom } from '../../../../helpers/urlHelper';
import { OPEN_PROJECT_ID } from '../../../../config/constant/curatorConstants';
import { setCuratorLoader } from '../../../../redux/slicers/admin/curatorSlicer';
import { setProjectZip } from '../../../../helpers/idb';
import { errorToast } from '../../../../helpers/toastHelper';
import { useResetCuratorState } from '../../../../hooks/useResetCuratorState';
import { isCuratorSaved } from '../../../../pages/admin/curator/curatorState';
import { useInfoDialogaActions } from '../../../../hooks/useInfoDialogaActions';
import { useUnityShortcuts } from './useUnityShortcuts';
//import { captureException } from '@sentry/react';

export const useOpenProjectFromFile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { openInfoDialog } = useInfoDialogaActions();
  const { resetCuratorState } = useResetCuratorState();
  const { saveProject } = useUnityShortcuts();

  const triggerFileSelection = ({ ignoreNotSaved } = {}) => {
    if (!ignoreNotSaved && !isCuratorSaved()) {
      openInfoDialog({
        title: 'Save Project',
        description: `Do you want to save your changes?`,
        cancelButtonText: 'No',
        buttonText: 'Yes',
        onCancelClick: () => {
          triggerFileSelection({ ignoreNotSaved: true });
        },
        onButtonClick: () => {
          saveProject();
        },
      });
      return;
    }

    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.zip';
    input.style.position = 'absolute';
    input.style.transform = 'translateX(-10000px)';
    input.addEventListener('change', (event) => {
      const file = event.target?.files?.[0];
      if (!file || !file.name.endsWith('.zip')) {
        errorToast('Please select a zip file');
        return;
      }

      openProjectFromFile(file);
    });

    input.addEventListener('blur', () => {
      document.body.removeChild(input);
    });

    document.body.appendChild(input);
    input.click();
  };

  const openProjectFromFile = async (file, { target } = {}) => {
    if (!file.name.endsWith('.zip')) {
      errorToast('File format not supported. Supported file format is .zip');
      return;
    }

    const { entries } = await unzip(file);
    const filePathList = Object.keys(entries);
    const jsonFilePath = filePathList.find((p) => p.endsWith('.json'));

    if (!jsonFilePath) {
      errorToast('Incorrect archive data. JSON configuration not found');
      return;
    }

    const zipUuid = uuidv4();

    try {
      await setProjectZip(file, zipUuid);
    } catch (e) {
      // add logger here
      console.error(e);
      //captureException(e);
      // fail silently, worst case scenario we will not show project to the user after refreshing the page
    }

    if (target === '_blank') {
      openCuratorRoom('open', { zipUuid });
    } else {
      // const shouldReplace = window.location.pathname.includes('/room/open') && !window.location.search.includes('renderId=')

      // reset curator state
      resetCuratorState();
      dispatch(setFile({ file, uuid: zipUuid }));
      navigate(getCuratorPath(OPEN_PROJECT_ID, 'room', { zipUuid }), { replace: false });
      dispatch(setCuratorLoader(false));
    }
  };

  return {
    openProjectFromFile,
    triggerFileSelection,
  };
};
